import styled from 'styled-components';

export const VideoResourcesWrapper = styled.div`
  h1 {
    font-weight: 700;
  }
`;

export const VideoResourcesContainer = styled.div`
  margin-top: 32px;
  display: grid;
  gap: 32px;
  grid-template-columns: repeat(3, 1fr);

  @media (max-width: ${({ theme }) => theme.breakpoints.large}) {
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.small}) {
    grid-template-columns: 1fr;
    gap: 16px;
  }
`;
